/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
declare const _PostCommentFormContainer_settings$ref: unique symbol;
export type PostCommentFormContainer_settings$ref = typeof _PostCommentFormContainer_settings$ref;
export type PostCommentFormContainer_settings = {
    readonly charCount: {
        readonly enabled: boolean;
        readonly min: number | null;
        readonly max: number | null;
    };
    readonly disableCommenting: {
        readonly enabled: boolean;
        readonly message: string;
    };
    readonly closeCommenting: {
        readonly message: string;
    };
    readonly " $refType": PostCommentFormContainer_settings$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enabled",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "PostCommentFormContainer_settings",
        "type": "Settings",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "charCount",
                "storageKey": null,
                "args": null,
                "concreteType": "CharCount",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "min",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "max",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "disableCommenting",
                "storageKey": null,
                "args": null,
                "concreteType": "DisableCommenting",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "closeCommenting",
                "storageKey": null,
                "args": null,
                "concreteType": "CloseCommenting",
                "plural": false,
                "selections": [
                    (v1 /*: any*/)
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'fc974fe7ff80b83acff3c4859b0282f2';
export default node;
